export const isTokenValid = () => {
  const token = localStorage.getItem("token");
  const expiry = localStorage.getItem("expiresAt");

  console.log("Token:", token, "Expiry (epoch):", expiry);

  if (!token || !expiry) return false;

  const now = Date.now(); // current time in ms
  const expiryTime = parseInt(expiry); // convert stored epoch string to number

  console.log("Now:", now, "ExpiryTime:", expiryTime);

  return now < expiryTime; // true → token still valid
};
